var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { ref: "container", staticStyle: { display: "none" } }),
    _vm._v(" "),
    _vm.showProdutoModal
      ? _c(
          "div",
          { staticClass: "lr-produto-modal-host" },
          [
            _c(
              "shortcutComponent",
              {
                ref: "shortcutProduto",
                attrs: { modalClass: "bg-modal", btOkName: "Salvar" },
                on: {
                  "selection-item": _vm.onConfirmarProduto,
                  "hide-click": _vm.onHideProduto,
                },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "component" }, slot: "component" },
                  [
                    _c("produtoComponent", {
                      ref: "produtoComponent",
                      attrs: {
                        isModal: true,
                        descricaoSugestao: _vm.nomeProdutoSugerido,
                      },
                      on: { "save-ok": _vm.onProdutoSaveOk },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }